<template>
    <div class="cooperate-form">
        <div class="content-header">
            <el-table :data="likeMe" stripe border center :size="GCONFIG.styleTableSize" style="margin: 18px 0">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column label="感谢我" prop="userNick" width="90"></el-table-column>
<!--                <el-table-column label="问题" prop="questionName"></el-table-column>-->
                <el-table-column label="内容">
                    <template slot-scope="scope">
                        <p v-html="scope.row.content" style="text-align: left"></p>
                    </template>
                </el-table-column>
                <el-table-column label="时间" prop="createTime" width="150"></el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        :hide-on-single-page="formInline.pageSize>=recordsTotal"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="recordsTotal">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>

    //定义组件
    export default {
        data() {
            return {
                formInline: {
                    currentPage: 1,
                    pageSize: 50,
                    classId:1,
                    ctype:5,
                    isself:0
                },
                likeMe:[],
                recordsTotal:0
            }
        },
        computed:{

        },
        props:['sectionClassId'],
        //挂载时候执行
        mounted() {
            this.formInline.classId = this.sectionClassId
            this.getCooperativeCallMe()
        },
        methods: {
            getCooperativeCallMe() {
                this.$store.dispatch('initCooperativeCallMe',this.formInline).then(res=>{
                    this.likeMe = res.list
                    this.recordsTotal = res.total
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getCooperativeCallMe()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getCooperativeCallMe()
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/cooperative/cooperativeThanks.vue